import React from "react";
import Memories from "../Dashboard/Memories";
import { Box } from "@mui/material";
const InvitationAlbum = () => {
	return (
		<Box p={2}>
			<Memories />
		</Box>
	);
};

export default InvitationAlbum;
